import http from "../http-common";
import ICarrierData from "../types/Carriers";

const getAll = (token?: string) => {
  return http.get<Array<ICarrierData>>('/api/Carrier', {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const getById = (flightNumber: string, token?: string) => {
  return http.get<ICarrierData>(`/api/Carrier/search?flightNumber=${flightNumber}`, {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const create = (requestBody: ICarrierData, token?: string) => {
  return http.post<ICarrierData>(
    '/api/Carrier',
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )
};

const remove = (id: number | string, token?: string) => {
  return http.delete<any>(`/api/Carrier/${id}`, {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const CarrierService = {
  getAll,
  getById,
  create,
  remove
};

export default CarrierService;